import styles from './ButtonTag.module.css'
import classNames from 'classnames'
import type { ButtonComponentProps, PrimaryVariantAnchorTypes, SecondaryVariantAnchorTypes } from '../Button.types'

type AnchorType = PrimaryVariantAnchorTypes | SecondaryVariantAnchorTypes

interface ButtonTagProps {
  props: ButtonComponentProps
  internalClass: string
  children: React.ReactNode
}

const ButtonTag = ({ props, internalClass, children }: ButtonTagProps) => {
  const blockClasses = classNames(styles.ButtonTag, internalClass)

  if ('href' in props) {
    return (
      <a className={blockClasses} {...(props as AnchorType)}>
        {children}
      </a>
    )
  }

  return (
    <button className={blockClasses} type={props.type || 'button'} {...props}>
      {children}
    </button>
  )
}

export default ButtonTag
